import React, { Fragment } from "react";

export const Enviroment = () => {
  return (
    <Fragment>
      {(() => {
        if (
          process.env.REACT_APP_URL_API ===
          "https://admin-develop.possumus.tech"
        ) {
          return <div className="warning dev">Dev</div>;
        } else if (
          process.env.REACT_APP_URL_API ===
          "https://admin-staging.possumus.tech"
        ) {
          return <div className="warning staging">Staging</div>;
        }
      })()}
    </Fragment>
  );
};

export default Enviroment;
